import React from "react";
import SocialMediaButton from "../fields/SocialMediaButton";

function Newsletter({ data }) {
    return (
        <div key={data.documentId} className="newsletter screen-width">
            <div className="row background-full-width newsletter-div medium-blue">
                <div className="container-fluid newsletter-container" style={{maxWidth: '1300px', display: 'flex'}}>
                    {/*<div className="col-xs-12 col-sm-8 newsletter-form no-padding" >*/}
                    {/*    <label htmlFor="email" className="white-text newsletter-label" hidden><h4>SIGN UP FOR OUR*/}
                    {/*        NEWSLETTER</h4></label>*/}
                    {/*    <div className="">*/}
                    {/*        <div className="newsletter-form-group" hidden>*/}
                    {/*            <article id="node-88" className="node node-webform node-promoted clearfix"*/}
                    {/*                     about="/node/88" typeof="sioc:Item foaf:Document">*/}
                    {/*                <header>*/}
                    {/*                    <h2><a href="https://cleanairpartners.net/node/88">Constant Contact Form</a>*/}
                    {/*                    </h2>*/}
                    {/*                    <span property="dc:title" content="Constant Contact Form"*/}
                    {/*                          className="rdf-meta element-hidden"></span>*/}
                    {/*                </header>*/}
                    {/*                <div id="webform-ajax-wrapper-88">*/}
                    {/*                    <form className="webform-client-form webform-client-form-88 webform-hints"*/}
                    {/*                          action="/aqi" method="post" id="webform-client-form-88"*/}
                    {/*                          accept-charset="UTF-8">*/}
                    {/*                        <div>*/}
                    {/*                            <div className="webform-component-cc_email"*/}
                    {/*                                 id="webform-component-email">*/}
                    {/*                                <div*/}
                    {/*                                    className="form-item webform-component webform-component-webform-cc-email webform-component--email--cc-email-address form-group form-item form-item-submitted-email-cc-email-address form-type-textfield form-group">*/}
                    {/*                                    <input title="Enter your email address"*/}
                    {/*                                           placeholder="Enter your email address"*/}
                    {/*                                           className="webform-hints-field form-control form-text required"*/}
                    {/*                                           type="text" id="edit-submitted-email-cc-email-address"*/}
                    {/*                                           name="submitted[email][cc_email_address]" value=""*/}
                    {/*                                           size="60" maxLength="128"/> <label*/}
                    {/*                                    className="control-label element-invisible"*/}
                    {/*                                    htmlFor="edit-submitted-email-cc-email-address">Enter your email*/}
                    {/*                                    address <span className="form-required"*/}
                    {/*                                                  title="This field is required.">*</span></label>*/}
                    {/*                                </div>*/}
                    {/*                            </div>*/}
                    {/*                            <input type="hidden" name="details[sid]"/>*/}
                    {/*                            <input type="hidden" name="details[page_num]" value="1"/>*/}
                    {/*                            <input type="hidden" name="details[page_count]" value="1"/>*/}
                    {/*                            <input type="hidden" name="details[finished]" value="0"/>*/}
                    {/*                            <input type="hidden" name="form_build_id"*/}
                    {/*                                   value="form-HPO_U_eF_y_TMrmK2ELDlRurmQMm1vvngaHJSMycH7U"/>*/}
                    {/*                            <input type="hidden" name="form_id" value="webform_client_form_88"/>*/}
                    {/*                            <input type="hidden" name="webform_ajax_wrapper_id"*/}
                    {/*                                   value="webform-ajax-wrapper-88"/>*/}
                    {/*                            <div className="form-actions">*/}
                    {/*                                <button*/}
                    {/*                                    className="webform-submit button-primary btn btn-default form-submit ajax-processed"*/}
                    {/*                                    type="submit" id="edit-webform-ajax-submit-88" name="op"*/}
                    {/*                                    value="SIGN UP">SIGN UP*/}
                    {/*                                </button>*/}
                    {/*                            </div>*/}
                    {/*                        </div>*/}
                    {/*                    </form>*/}
                    {/*                </div>*/}
                    {/*            </article>*/}
                    {/*        </div>*/}

                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className={'col-xs-12 col-sm-4'}></div>

                    <div className="col-xs-12 col-sm-4 newsletter-social-media" style={{textAlign: 'center'}}>
                        <div className="">
                            <p className="white-text">
                                FOLLOW US
                            </p>
                            {data.socialMediaButtons.map((item, index) => (
                                <SocialMediaButton data={item}/>
                            ))}
                        </div>
                    </div>

                    <div className={'col-xs-12 col-sm-4'}></div>
                </div>

            </div>
        </div>
    );
}

export default Newsletter;
